import { Col, Row, Checkbox, Divider } from "antd";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  toGetAllContactMethods,
  toEditSponsor,
  getSponsorDetails,
} from "../../../../apis/actions/sponsor.actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import Selects from "../../../../biblio/Selects/Selects";
import Inputs from "../../../../biblio/Inputs/Inputs";
import { getAllNationality } from "../../../../apis/actions/recipient.actions";
import SecondaryButton from "../../../../biblio/Buttons/SecondaryButton";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import { showNotitfication } from "../../../../components/utils/utils";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import {
  getParticipantDetails,
  
} from "../../../../apis/actions/participants.actions";
interface InfoProps {
  infoArray: any;
}

const SponsorInfoContent = ({ infoArray }: InfoProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { contact_methods } = useSelector((state: RootState) => state.sponsor);
  const { nationality } = useSelector((state: RootState) => state.recipient);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [emailError, setEmailError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const OtpId =  useSelector(
    (state: RootState) => state?.recipient?.OtpId
  );
  const getNationalityIdByName = (name: string) => {
    const match = nationality?.data?.find((item: any) => item.name === name);
    return match?.id || "";
  };
  const [editableInfo, setEditableInfo] = useState({
    eng_name: infoArray?.eng_name || "",
    street: infoArray?.street || "",
    email: infoArray?.email || "",
    contact_method_ids:
      infoArray?.contact_method_ids?.map((method: any) => method.id) || [],
    nationality_id: getNationalityIdByName(infoArray.nationality_id),
    want_attending_orphan_sponsor_meeting:
      infoArray?.want_attending_orphan_sponsor_meeting,
    allow_send_reminder_sms: infoArray?.allow_send_reminder_sms,
  });
  useEffect(() => {
    dispatch(toGetAllContactMethods());
    dispatch(getAllNationality());
  }, [dispatch]);

  const handleInputChange = (field: string, value: any | any[]) => {
    setEditableInfo({ ...editableInfo, [field]: value });
    if (field === "email") {
      setEmailError(null); 
    }
  };
  const handleSelectChange = (field: string, value: any) => {
    if (field === "contact_method_ids") {
      setEditableInfo({
        ...editableInfo,
        [field]: value.map((option: any) => option.value),
      });
    } else {
      setEditableInfo({ ...editableInfo, [field]: value.value });
    }
  };
  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const openModalWithValidation = () => {
    if (!validateEmail(editableInfo.email)) {
      setEmailError("يجب التأكد من أن البريد الإلكتروني مكتوب بشكل صحيح.");
    } else {
      setIsModalVisible(true);
    }
  };
  const cancelModification = () => {
    setIsModalVisible(false);
  };
  const confirmModification = () => {
    try {
      setIsSubmitting(true);
      if (editableInfo.nationality_id === undefined || editableInfo.nationality_id === "") {
        delete editableInfo.nationality_id;
      }
      const updatedInfo = { 
        ...editableInfo, 
        partner_id: OtpId
      };
      dispatch(toEditSponsor(updatedInfo)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalVisible(false);
          dispatch(getSponsorDetails({ sponsor_id: OtpId}));
          dispatch(getParticipantDetails());
        } else {
          showNotitfication(response?.message, "error");
          setIsModalVisible(false);
        }
        setIsSubmitting(false);
      });
    } catch (error) {
      console.error(error);
      setIsSubmitting(false);
    }
  };  
  return (
    <>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الإسم</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.name}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>الإسم بالإنجليزي </p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          style={{ paddingTop: "0.5rem" }}
        >
          <Inputs
            value={editableInfo.eng_name}
            onChange={(e) => handleInputChange("eng_name", e.target.value)}
          />
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>رقم الكافل</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.sponsor_number}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>تاريخ طلب الكفالة</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>
            {infoArray?.sponsorship_request_date &&
              new Date(infoArray.sponsorship_request_date).toLocaleDateString()}
          </span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الجنس</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{t(`gender.${infoArray?.gender}`)}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>نوع الهوية</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.identification_type_id}</span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>رقم الهوية</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.identification_number}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>تاريخها </p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>
            {infoArray?.identification_date &&
              new Date(infoArray.identification_date).toLocaleDateString()}
          </span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الهاتف</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.mobile}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>البريد الإلكتروني</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <Inputs
            value={editableInfo.email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            type="email"
          />
                {emailError && (
            <span style={{ color: "red", fontSize: "12px" }}>{emailError}</span>
          )}
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>العنوان الوطني</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <Inputs
            value={editableInfo.street}
            onChange={(e) => handleInputChange("street", e.target.value)}
          />
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>الجنسية</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <Selects
            options={nationality?.data || []}
            className="takaful--select"
            selectPlaceholder="اختر الجنسية"
            onChange={(value) =>
              handleSelectChange("nationality_id", value ? value : "")
            }
            value={editableInfo.nationality_id}
          />
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>طرق التواصل</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <Selects
            options={contact_methods || []}
            mode="multiple"
            className="takaful--select-multiple"
            selectPlaceholder="اختر طرق التواصل"
            onChange={(value) =>
              handleSelectChange("contact_method_ids", value)
            }
            value={editableInfo.contact_method_ids}
          />
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}></Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}></Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={9}
          xl={9}
          lg={9}
          md={9}
          sm={15}
          xs={15}
          className="takaful--content-profile-col"
        >
          <p>هل ترغب الحضور في برنامج لقاء الكفلاء بالأيتام</p>
        </Col>
        <Col
          xxl={2}
          xl={2}
          lg={2}
          md={2}
          sm={9}
          xs={9}
          className="takaful--content-profile-col"
        >
          <Checkbox
            checked={editableInfo.want_attending_orphan_sponsor_meeting}
            onChange={(e) =>
              handleInputChange(
                "want_attending_orphan_sponsor_meeting",
                e.target.checked
              )
            }
          ></Checkbox>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={9} xl={9} lg={9} md={9} sm={15} xs={15}>
          <p>السماح بإرسال رسائل تذكير بالسداد</p>
        </Col>
        <Col
          xxl={2}
          xl={2}
          lg={2}
          md={2}
          sm={9}
          xs={9}
        >
          <Checkbox
            checked={editableInfo.allow_send_reminder_sms}
            onChange={(e) =>
              handleInputChange("allow_send_reminder_sms", e.target.checked)
            }
          ></Checkbox>
        </Col>
      </Row>

      <Divider className="takaful--service-section-divider" />

      <Row className="takaful--content-profile-box1">
        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
          <div className="takaful--content-profile-title">
            <h1>الحساب البنكي</h1>
          </div>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>إسم صاحب الحساب</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.acc_holder_name}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>رقم الحساب</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.acc_number}</span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>البنك</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          {Array.isArray(infoArray?.bank_id) &&
            infoArray?.bank_id.length > 1 && (
              <span>{infoArray?.bank_id[1]}</span>
            )}
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}></Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}></Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={10}
          className="takaful--content-profile-col"
        ></Col>
        <div className="takaful--sponsor-secondary-button">
          <SecondaryButton
            title="تعديل"
            onClick={openModalWithValidation}
          />
        </div>
      </Row>
      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={cancelModification}
        closeOnOutsideClick={true}
        centered={true}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">
            هل أنت متأكد أنك تريد إعتماد التعديل؟
          </p>
        </Row>
        <Row gutter={16} justify={"center"} style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--cancel-btn-logout"
              disabled={isSubmitting}
              onClick={cancelModification}
              title="لا"
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--confirm-btn-logout"
              title="نعم"
              disabled={isSubmitting}
              loading={isSubmitting}
              onClick={confirmModification}
            />
          </Col>
        </Row>
      </ModalComponent>
    </>
  );
};

export default SponsorInfoContent;
